import {Component} from "react";
import ModelList from "./ModelList";
import {connect} from "react-redux";
import {formValueSelector} from "redux-form";
import React from "react";
import SVG from 'react-inlinesvg';
import tickSvg from "../images/Tick.svg"

function ModelListContainer(props) {

    class MLContainer extends Component {


        render() {

            if (this.props.models !== undefined && this.props.models.length > 0) {

                const m = this.props.models ? this.props.models.map((i) => i.toLowerCase().trim()) : [];
                const t = this.props.vehicle && this.props.vehicle.trim().length > 0 ? this.props.vehicle.toLowerCase().trim() : "";
                const vehicleSelected = m.includes(t);
                const className = vehicleSelected ? `text-center selected m-3 row ` : ` m-3 text-center row`;

                return (<div className={className}>
                    <ModelList formName={props.formName} items={this.props.models} brandConfig={this.props.brandConfig}
                               imagebase={'https://assets.fcaab.com.au/assets-public/vpc/images/jeep/1501'}
                        handleClick={props.handleClick}
                        brand={this.props.brand}
                    />
                </div>)
            } else {
                return (
                    <div className={"row justify-content-center m-3"}>
                        <h4>Loading Models</h4>
                    </div>
                )
            }

        }
    }

    const MLContainerComponent = connect((state) => {
        const selector = formValueSelector(props.formName);
        return {
            models: selector(state, props.items),
            vehicle : selector(state,'vehicle'),
            brandConfig : selector(state,'brandConfig')
        }
    })(MLContainer);

    return <MLContainerComponent {...props}/>
}


export function SelectModel(p){

    const {formName, icon, vehicle} = p;

    function Component(props){
        const m = props.models ? props.models.map((i) => i.toLowerCase()) : [];
        const t = props.vehicle && props.vehicle.trim().length > 0 ? props.vehicle.toLowerCase() : "";

        function parseQueryString(queryString) {
            const params = {};
            const queryStringWithoutQuestionMark = queryString.substring(1);
            queryStringWithoutQuestionMark.split("&").forEach((param) => {
                const [key, value] = param.split("=");
                params[key] = decodeURIComponent(value);
            });
            return params;
        }

        const queryParams = parseQueryString(window.location.search);
        let brand = "";
        if(typeof queryParams["brand"] !== "undefined"){
            brand = queryParams["brand"];
        }

        const className = m.includes(t) ? ` selected ` : `  `;
        const handleClick = props.handleClick ? props.handleClick : () => {
        };

        return (
            <div className={`select-model ${className}`}>
                <div className={" col-12 d-flex justify-content-center section-heading"}>
                    {!m.includes(t) && <SVG src={icon}/> }
                    {m.includes(t) && <SVG className={' selected '} src={tickSvg}/>}
                    <h4 className={"pt-1 pl-1"}>
                        SELECT MODEL</h4>
                </div>

                <ModelListContainer handleClick={handleClick}  formName={formName} items={"models"} brand={brand}/>

            </div>
        )
    };

    const SelectModelComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            vehicle : selector(state, 'vehicle') || '',
            models : selector(state, 'models'),
            brandConfig : selector(state,'brandConfig'),
            formState : selector(state, 'formState'),
        }
    })(Component);

    return <SelectModelComponent {...p} />
}

export default ModelListContainer;
